import { render, staticRenderFns } from "./tabPane.vue?vue&type=template&id=3eda1569&scoped=true"
import script from "./tabPane.vue?vue&type=script&lang=js"
export * from "./tabPane.vue?vue&type=script&lang=js"
import style0 from "./tabPane.vue?vue&type=style&index=0&id=3eda1569&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eda1569",
  null
  
)

export default component.exports